import React from 'react';
import { Form, FormDef, SelectOption } from '@esportal/portal-service';
import { TypeDocumentEnum } from '@esportal/portal-service';

export const NIF_REGEX = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
export const NIE_REGEX = /^([XYZ])(\d{7,8})([A-Z])$/;
export const PERSON_NAME_REGEX =
	/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{2,}$/u;

export const validateNoEmpty = (data: any) => {
	return data != null && data !== undefined && data !== '' ? null : 'empty-field';
};

export const validatePersonName = (data: any) => {
	return validateNoEmpty(data) || data.match(PERSON_NAME_REGEX) ? null : 'wrong-name';
};

export const validateNIF = (nif: any) => {
	const dni_letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
	const letter = dni_letters.charAt(parseInt(nif, 10) % 23);
	return letter === nif.charAt(8) ? null : 'wrong-dni';
};

export const validateWrongDni = (data: any, formData: any) => {
	if (formData.typeDocument && !validateNoEmpty(data)) {
		if (formData.typeDocument === TypeDocumentEnum.DNI_NIF) {
			const match = data.match(NIF_REGEX);
			if (match) {
				return validateNIF(match[0]);
			}
		} else if (formData.typeDocument === TypeDocumentEnum.NIE) {
			const match = data.match(NIE_REGEX);
			if (match) {
				let nie_prefix = match[0].charAt(0);

				switch (nie_prefix) {
					case 'X':
						nie_prefix = 0;
						break;
					case 'Y':
						nie_prefix = 1;
						break;
					case 'Z':
						nie_prefix = 2;
						break;
				}

				return validateNIF(nie_prefix + match[0].substr(1));
			}
		}
	}
	return 'wrong-dni';
};

export const getFormValues = (form: Form): any => {
	let formValues = {};
	for (const formProperty in form.fields) {
		formValues = {
			...formValues,
			[formProperty]: form.fields[formProperty].value,
		};
	}
	return formValues;
};

export const updateValidateFormField = (form: Form, name: string, value: any, modeBlur = false): Form => {
	let formUpdated = { ...form };
	formUpdated.fields = !modeBlur ? setFormFieldValue(formUpdated, name, value) : deflowerField(formUpdated, name);
	formUpdated = validateFormErrors(formUpdated);
	return formUpdated;
};

export const generateSelectOptions = (selectOptions: SelectOption[]) => {
	return selectOptions.map((option: SelectOption, index: number) => (
		<option key={index} value={option.value}>
			{option.label}
		</option>
	));
};

export const hasFormFieldError = (field: FormDef, includePristine = false): boolean => {
	return field.error.length && ((!includePristine && !field.virgin) || includePristine) ? true : false;
};

const setFormFieldValue = (form: Form, field: string, value: any) => {
	return {
		...form.fields,
		[field]: { ...form.fields[field], value, virgin: false },
	};
};

const setFormFieldErrors = (form: Form, field: string, errors: string[]) => {
	return { ...form.fields, [field]: { ...form.fields[field], error: [...errors] } };
};

const validateFormFieldErrors = (formField: FormDef, value: any, formValues: any) => {
	const errors: string[] = [];
	for (const validation of formField.validators) {
		const resultValidation: string | null = validation(value, formValues);
		resultValidation && resultValidation !== '' && errors.push(resultValidation);
	}
	return errors;
};

const validateFormErrors = (form: Form) => {
	let isValid = true;

	for (const formProperty in form.fields) {
		const errors: string[] = validateFormFieldErrors(
			form.fields[formProperty],
			form.fields[formProperty].value,
			getFormValues(form),
		);
		isValid = isValid && errors.length === 0;

		form.fields = setFormFieldErrors(form, formProperty, errors);
	}

	form.isValid = isValid;

	return form;
};

export const deflowerField = (form: Form, field: string): { [type: string]: FormDef } => {
	return {
		...form.fields,
		[field]: { ...form.fields[field], virgin: false },
	};
};
